export const isFlexibleReportsM2P1Enabled = () => {
  return window.AppContext?.isFlexibleReportsM2P1Enabled === 'true';
};

export const isCaracalOnlineExperienceEnabled = () => {
  return window.AppContext?.isCaracalUnboxedP0Enabled === 'true';
};

export const isFlexibleReportsCampaignFilterEnabled = () => {
  return window.AppContext?.isFlexibleReportsM2CampaignsFilterEnabled === 'true';
};

export const isFlexibleReportsFeedbackSystemEnabled = () => {
  return window.AppContext?.isFlexibleReportsFeedbackSystemEnabled === 'true';
};

export const isCostEstimationLaunchEnabled = () => {
  return window.AppContext?.isCostEstimationLaunchEnabled === 'true';
};

export const isUnifiedReportingEnabled = () => {
  return window.AppContext?.isUnifiedReportingEnabled === 'true';
};

export const isExtendedHistoricalDataEnabled = () => {
  return window.AppContext?.isDatePresetEnabled === 'true';
};

export const isTimeZoneEnabled = () => {
  return window.AppContext?.isTimeZoneEnabled === 'true';
};

export const isCaracalCovEnabled = () => {
  return window.AppContext?.isCaracalCovEnabled === 'true';
};

export const defaultCovFromAppContext = () => {
  return (window.AppContext?.currencyOfVisualization as string) || 'USD';
};

export const isManagerAccountReportingEnabled = () => {
  return window.AppContext?.isCaracalManagerAccountsEnabled === 'true';
};

export const shouldExcludeManagerAccounts = (): boolean => {
  return isUnifiedReportingEnabled() && !isManagerAccountReportingEnabled();
};

export const isCaracalSpProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSpProductTypeOptionEnabled === 'true';
};

export const isCaracalSbProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSbProductTypeOptionEnabled === 'true';
};

export const isCaracalSdProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalSdProductTypeOptionEnabled === 'true';
};

export const isCaracalStvProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalStvProductTypeOptionEnabled === 'true';
};

export const isCaracalOtherProductTypeOptionEnabled = () => {
  return window.AppContext?.isCaracalOtherProductTypeOptionEnabled === 'true';
};

export const isCaracalMetadataDefaultLocaleEnabled = () => {
  return window.AppContext?.isCaracalMetadataDefaultLocaleEnabled === 'true';
};

export const isCaracalOutageBannerEnabled = () => {
  return window.AppContext?.isCaracalOutageBannerEnabled === 'true';
};

export const isCaracalReportAnalysisEnabled = () => {
  return window.AppContext?.isCaracalReportAnalysisEnabled === 'true';
};

export const isCaracalReportHmhEnabled = () => {
  return window.AppContext?.isCaracalReportHmhEnabled === 'true';
};

export const isCaracalSaveAndRunFeatureEnabled = () => {
  return window.AppContext?.isCaracalSaveAndRunFeatureEnabled === 'true';
};
